import axios from "axios";

export const http = axios.create({
  //baseURL: 'http://apppanterafood.com.br/DeliveryCenter/3/cardapio/',
  //baseURL: 'http://192.168.1.27/cardapio/',
  //baseURL: '../', //LOCAL DA RAIZ
  //baseURL: '../cardapio/', //SERVIDOR DA PASTA 3
  baseURL: "./", //LOCAL DA PASTA 3
  contrato: "",
});
